const resources = [
  {
    category: "Passport Photos",
    icon: "ri-camera-line",
    items: [
      { name: "Walgreens — Anchorage", address: "2000 W Dimond Blvd, Anchorage, AK 99515" },
      { name: "Costco Photo Center — Anchorage", address: "330 W Dimond Blvd, Anchorage, AK 99515" },
      { name: "FedEx Office — Midtown Anchorage", address: "3900 Old Seward Hwy, Anchorage, AK 99503" },
    ],
  },
  {
    category: "Alaska DMV — ID Documents",
    icon: "ri-id-card-line",
    items: [
      { name: "DMV — Anchorage Main", address: "2150 E Dowling Rd, Anchorage, AK 99507" },
      { name: "DMV — Eagle River", address: "11901 Eagle River Rd, Eagle River, AK 99577" },
      { name: "DMV — Abbott Loop", address: "4111 Aviation Ave, Anchorage, AK 99502" },
    ],
  },
  {
    category: "Airports",
    icon: "ri-plane-line",
    items: [
      { name: "Ted Stevens Anchorage International Airport (ANC)", address: "5000 W International Airport Rd, Anchorage, AK 99502" },
      { name: "Merrill Field Airport", address: "800 Merrill Field Dr, Anchorage, AK 99501" },
    ],
  },
];

export default function HelpfulResourcesSection() {
  return (
    <section id="local-resources" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Resources</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Helpful Resources for Anchorage Passport Applicants
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Local businesses and offices in Anchorage that can help you prepare your passport application.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {resources.map((group, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#EEF2F8] mb-4">
                <i className={`${group.icon} text-[#1A365D] text-lg`}></i>
              </div>
              <h3 className="font-bold text-[#1A365D] text-sm mb-4">{group.category}</h3>
              <ul className="space-y-4">
                {group.items.map((item, j) => (
                  <li key={j} className="border-t border-gray-100 pt-3">
                    <p className="font-semibold text-[#1A365D] text-xs">{item.name}</p>
                    <p className="text-gray-400 text-xs mt-0.5">{item.address}</p>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-500 text-sm mb-4">
            Other Alaska cities we serve:
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            {[
              { name: "Alaska State Hub", href: "/alaska" },
              { name: "Fairbanks", href: "/fairbanks-ak" },
              { name: "Juneau", href: "/juneau" },
            ].map((city) => (
              <a
                key={city.href}
                href={city.href}
                className="text-sm font-semibold text-[#1A365D] hover:text-[#F6C344] transition-colors whitespace-nowrap underline underline-offset-2"
              >
                {city.name}
              </a>
            ))}
          </div>
        </div>

        {/* Vital Records */}
        <div className="mt-12 bg-white rounded-lg border border-gray-200 overflow-hidden">
          <div className="bg-[#1A365D] px-6 py-5 flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-white/15 flex-shrink-0">
              <i className="ri-file-text-line text-white text-lg"></i>
            </div>
            <div>
              <p className="text-white/60 text-xs font-semibold uppercase tracking-widest">Vital Records</p>
              <p className="text-white font-bold text-base leading-tight mt-0.5">Alaska Vital Records for Passport Applications</p>
            </div>
          </div>
          <div className="px-6 py-6">
            <p className="text-gray-500 text-sm leading-relaxed mb-5">
              If you need certified copies of birth, death, marriage, or divorce records for your passport application, these Alaska agencies can help:
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {[
                { label: "Birth Certificate", agency: "Alaska Department of Health — Vital Records", address: "3601 C St, Suite 570, Anchorage, AK 99503", url: "https://health.alaska.gov/dph/VitalStats/" },
                { label: "Death Certificate", agency: "Alaska Department of Health — Vital Records", address: "3601 C St, Suite 570, Anchorage, AK 99503", url: "https://health.alaska.gov/dph/VitalStats/" },
                { label: "Marriage Certificate", agency: "Alaska Department of Health — Vital Records", address: "3601 C St, Suite 570, Anchorage, AK 99503", url: "https://health.alaska.gov/dph/VitalStats/" },
                { label: "Divorce Decree", agency: "Alaska Court System", address: "825 W 4th Ave, Anchorage, AK 99501", url: "https://courts.alaska.gov/" },
              ].map((record, i) => (
                <a key={i} href={record.url} target="_blank" rel="noopener noreferrer nofollow" className="flex items-start gap-3 bg-[#F7F8FA] border border-gray-200 rounded-lg p-4 hover:border-[#F6C344] transition-colors group">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0 mt-0.5">
                    <i className="ri-file-text-line text-[#1A365D] text-base"></i>
                  </div>
                  <div className="min-w-0">
                    <p className="font-bold text-[#1A365D] text-xs leading-snug group-hover:text-[#F6C344] transition-colors">{record.label}</p>
                    <p className="text-gray-500 text-xs mt-0.5">{record.agency}</p>
                    <p className="text-gray-400 text-xs mt-0.5">{record.address}</p>
                  </div>
                  <i className="ri-external-link-line text-gray-400 ml-auto flex-shrink-0"></i>
                </a>
              ))}
            </div>
            <div className="mt-4 bg-amber-50 border border-amber-200 rounded-md p-3">
              <p className="text-gray-600 text-xs leading-relaxed">
                <i className="ri-information-line text-amber-500 mr-1.5"></i>
                For out-of-state records, you can also use <a href="https://www.vitalchek.com/" target="_blank" rel="noopener noreferrer nofollow" className="font-bold text-[#1A365D] underline underline-offset-2 hover:text-[#F6C344] transition-colors">VitalChek</a> to order certified copies from any U.S. state.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}